import { Button } from '../../../../../design-system/button/button';
import { Modal, ModalContent, ModalDescription, ModalTitle } from '../../../../../design-system/modal/modal';
import { Stack } from '../../../../../design-system/stack/stack';

type AccountConnectedErrorModalProps = {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

export const AccountConnectedErrorModal = ({ isOpen, onOpenChange }: AccountConnectedErrorModalProps) => {
  return (
    <Modal open={isOpen} onOpenChange={onOpenChange}>
      <ModalContent className="h-48 max-w-sm bg-white p-6">
        <Stack space={3} align="center" justify="between">
          <Stack space={3} align="center">
            <ModalTitle>Account Connection Error</ModalTitle>
            <ModalDescription className="text-center text-sm font-medium text-muted-foreground">
              There was a problem connecting your account. Please try again.
            </ModalDescription>
          </Stack>

          <Button className="w-full" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </Stack>
      </ModalContent>
    </Modal>
  );
};
